import React from 'react';
import { PDFDownloadLink, Page, Text, Image, View, Document, StyleSheet } from '@react-pdf/renderer';
import { SystemText } from '@salesperformanceint/e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const st = (path, ...rest) => SystemText(`Objective/Pitchback/PDF/${path}`, ...rest);

// Create styles
const styles = StyleSheet.create({
    table: {
        alignItems: 'left',
        display: 'table',
        width: 520,
        borderWidth: 0,
    },
    tableRow: { margin: 'auto', display: 'flex', flexDirection: 'row', width: 520 },
    tableColFlag: { borderStyle: 'solid', borderWidth: 0, borderBottomWidth: 1, flexBasis: 20 },
    tableCol: {
        borderStyle: 'solid',
        marginLeft: 0,
        borderWidth: 0,
        borderBottomWidth: 1,
        alignItems: 'right',
        flexBasis: 70,
    },
    tableColDate: { borderStyle: 'solid', borderWidth: 0, borderBottomWidth: 1, flexBasis: 90, alignItems: 'right' },
    tableColFill: { borderStyle: 'solid', borderWidth: 0, borderBottomWidth: 1, flexGrow: 1 },
    tableColFlagNoEnd: { borderStyle: 'solid', borderWidth: 0, flexBasis: 20 },
    tableColNoEnd: { borderStyle: 'solid', marginLeft: 0, borderWidth: 0, alignItems: 'right', flexBasis: 70 },
    tableColDateNoEnd: { borderStyle: 'solid', borderWidth: 0, flexBasis: 90, alignItems: 'right' },
    tableColFillNoEnd: { borderStyle: 'solid', borderWidth: 0, flexGrow: 1 },
    tableCell: { fontSize: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 0, paddingRight: 0 },
    tableColExtra: { display: 'flex', flexDirection: 'row', paddingLeft: 10, paddingBottom: 5, marginRight: 10 },
    textSmall: { fontSize: 8, marginBottom: 5, marginRight: 5 },
    tableCellFill: { fontSize: 10, padding: 10, maxWidth: 300, textOverflow: 'ellipsis' },
    page: {
        flexDirection: 'column',
        backgroundColor: '#ebebeb',
        margin: 0,
        padding: 20,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: 20,
    },
    icon: {
        height: 8,
        marginBottom: 5,
        marginRight: 2,
    },
    logo: {
        height: 25,
        marginRight: 5,
    },
    headerText: {},
    headerName: { flexGrow: 1, textAlign: 'right' },
    infoBox: {
        flexDirection: 'row',
        backgroundColor: '#ffffff',
        border: 'solid 1px #a0a0a0',
        borderRadius: 3,
        padding: 20,
        paddingBottom: 10,
        marginBottom: 20,
    },
    info: { width: 300 },
    infoList: { flexDirection: 'column' },
    label: {
        fontSize: 12,
        marginBottom: 3,
    },
    labelValue: {
        fontSize: 10,
        marginBottom: 10,
    },
    flag: {
        width: 20,
        height: 20,
        marginTop: 5,
    },
});

export const TranscriptPDF = ({ transcript, objective, fileName }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <Image style={styles.logo} src="/dist/img/richardson-logo_sm.png"></Image>
                    <Text style={styles.headerText}>{SystemText('Reviews/Appraisals/PDF/Company')}</Text>
                    <Text style={styles.headerName}>{SystemText(`Objective/Pitchback/Tabs/Transcript`)}</Text>
                </View>
                <View style={styles.infoBox}>
                    <View style={styles.info}>
                        <Text style={styles.label}>{st('Employee')}</Text>
                        <Text style={styles.labelValue}>{objective.assigned_Fullname}</Text>
                        <Text style={styles.label}>{st('Owner')}</Text>
                        <Text style={styles.labelValue}>{objective.owner_Fullname}</Text>
                    </View>
                    <View style={styles.info}>
                        <Text style={styles.label}>{st('Due')}</Text>
                        <Text style={styles.labelValue}>{e4Format(objective.due)}</Text>
                        <Text style={styles.label}>{st('Completed')}</Text>
                        <Text style={styles.labelValue}>{e4Format(objective.date_Completed)}</Text>
                    </View>
                </View>
                <View style={styles.infoBox}>
                    <View style={styles.table}>
                        {/* TableContent */}
                        {transcript.map((t, i) => {
                            return (
                                <>
                                    <View wrap={false} key={`table-${i}`} style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t.instances[0].start?.split('.')[0]}</Text>
                                        </View>
                                        <View style={styles.tableColFill}>
                                            <Text style={styles.tableCell}>{t.text}</Text>
                                        </View>
                                    </View>
                                </>
                            );
                        })}
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export const PDF = ({ transcript, objective }) => {
    return (
        <div>
            <PDFDownloadLink
                document={<TranscriptPDF transcript={transcript} objective={objective} />}
                fileName={`Richardson-Insights-Transcript-${objective.assigned_Fullname.replace(' ', '-')}-${e4Format(
                    objective.date_Completed,
                    e4Formats.urlSafe
                )}.pdf`}
            >
                {({ blob, url, loading, error }) =>
                    error ? (
                        `ERROR:${error}`
                    ) : loading ? (
                        SystemText('Objective/Pitchback/LoadingDoc')
                    ) : (
                        <button className="btn btn-link" data-testid="button-pdf">
                            <i className="fa fa-download mr5" />
                            {SystemText('Objective/Pitchback/Download')}
                        </button>
                    )
                }
            </PDFDownloadLink>
        </div>
    );
};

export default React.memo(PDF);
